import { Spinner, Text } from "@radix-ui/themes"
import type { UiWallet } from "@wallet-standard/react"
import React from "react"

type Props = Readonly<{
  children?: React.ReactNode
  loading?: boolean
  wallet: UiWallet
}>

export function WalletMenuItemContent({ children, loading, wallet }: Props) {
  return (
    <div className="flex items-center gap-2">
      <Spinner loading={!!loading}>
        {/* <Avatar
          fallback={<Text size="1">{wallet.name.slice(0, 1)}</Text>}
          radius="none"
          src={wallet.icon}
          style={{ height: 4, width: 4 }}
        /> */}
        <img src={wallet.icon} alt={wallet.name} className="h-4 w-4" />
      </Spinner>
      <Text truncate>{children ?? wallet.name}</Text>
    </div>
  )
}
